export function CreateEvent() {
  return <p>Create an Event</p>;
}
